import { List } from "@mui/material";
import { useLocation, useParams } from "react-router-dom";
import { useMemo } from "react";
import NavigationItem from "./NavigationItem";
import useStatuses from "../../context/status/useStatuses";
import { ALUMNI_NAV_ITEM, EXAMS_INFO_NAV_ITEM, navigationHelper } from "../../helpers/navigation.helper";
import { hasPermission, PERMISSIONS } from "../../constants/permissions";
import { useStudents } from "../../context/students";
import { useFeatures } from "../../context/features";
import "./Navigation.css";
import { STUDENT_STATUS } from "../../constants/student.status";

const Navigation = (props) => {
    const { onItemClick } = props;
    const { pathname } = useLocation();
    const { studentId } = useParams();
    const { isFeatureEnabled } = useFeatures();
    const {
        isLockedStatus, studentStatus, showConsultationCall, hideSubjectSelectionUS,
        showRenewal, generalStatuses,
    } = useStatuses();
    const {
        permissions, alumni, activeStudent, activeStudentId,
    } = useStudents();

    const canContractsView = hasPermission(permissions, PERMISSIONS.CONTRACTS_MANAGE);
    const canFinanceView = hasPermission(permissions, PERMISSIONS.FINANCE_MANAGE);

    const hideFinanceItem = !canContractsView && !canFinanceView;
    const showExamsInfo = useMemo(
        () => isFeatureEnabled("_parent.examinformation.enabled") && studentStatus === STUDENT_STATUS.STUDENT && generalStatuses?.student?.yearGroup >= 7,
        [studentStatus, generalStatuses?.student?.yearGroup, isFeatureEnabled],
    );
    const showAlumni = isFeatureEnabled("_parent.returningstudents.enabled") && alumni?.length > 0;
    const isSingle = useMemo(() => ["", "/", "/my-details"].includes(pathname) && !activeStudentId, [pathname, activeStudentId]);
    const isImpersonate = useMemo(() => pathname.startsWith("/impersonate"), [pathname]);
    const isAlumniEnrolment = useMemo(() => pathname.includes("alumni") && !!studentId, [pathname, studentId]);
    const isAlumniOverallPage = useMemo(() => pathname.includes("alumni") && !studentId, [pathname, studentId]);
    const hideMentorPathway = activeStudent?.mentorPathwayStartDate == null && activeStudent?.mentorPathwayFinishDate == null;

    const navigationItems = useMemo(() => {
        let returned = navigationHelper.getNavigation(
            studentStatus,
            isLockedStatus,
            !showConsultationCall,
            hideSubjectSelectionUS,
            hideFinanceItem,
            showRenewal,
            hideMentorPathway,
            isAlumniOverallPage,
        );

        if (showAlumni) returned = [...returned, ALUMNI_NAV_ITEM];
        if (showExamsInfo) returned = [...returned, EXAMS_INFO_NAV_ITEM];

        return returned.map((item) => ({ ...item, disabled: !isSingle && !isImpersonate && !isAlumniOverallPage && !studentStatus }));
    }, [studentStatus, isAlumniOverallPage, isSingle, isImpersonate, isLockedStatus, showConsultationCall, hideSubjectSelectionUS, hideFinanceItem, showRenewal, showAlumni, showExamsInfo, hideMentorPathway]);

    const activePathname = studentId ? pathname.replace(`/${studentId}`, "") : pathname;

    return (
        <List className="Navigation" component="nav">
            {navigationItems.map((item) => (
                <NavigationItem
                    key={item.titleKey}
                    icon={item.icon}
                    titleKey={item.titleKey}
                    link={`${item.link}${item.requiredId ? `/${activeStudentId}` : ""}`}
                    isActive={item.strictActive
                        ? item.link === activePathname
                        : (activePathname === "" ? item.link === "/" : activePathname.includes(item.link))}
                    disabled={item.disabled || isAlumniEnrolment}
                    onItemClick={onItemClick}
                />
            ))}
        </List>
    );
};

export default Navigation;
